export const VALID_CATEGORIES = [
  'unusuals',
  'general',
  'strange',
  'haunted',
  'vintage',
  "collector's",
] as const;
export type PricingCategory = typeof VALID_CATEGORIES[number];

export const VALID_SORT = ['id', 'price', 'added', 'updated', 'previous_price'] as const;
export type PricingSort = typeof VALID_SORT[number];

export const VALID_ORDER = ['ASC', 'DESC'] as const;
export type PricingOrder = typeof VALID_ORDER[number];

export const DEFAULT_MARKUP_PERCENT = 10;
export const DEFAULT_KEY_PRICE = 2.5;

export interface PricingItem {
  id: number;
  name: string;
  image: string | null;
  price: string;                // server returns string USD
  previous_price: string | null;
  link: string | null;
  category: string;             // server returns capitalized e.g. "General" — normalize in UI where needed
  buy_orders: number[] | null;
  sell_orders: number[] | null;
  added: string;
  added_unix: number;
  updated: string;
  updated_unix: number;
  added_by: string | null;
  added_by_data: unknown | null;
  updated_by: string | null;
  updated_by_data: unknown | null;
  last_scraped: string | null;
  last_scraped_unix: number;
  is_ignored: 0 | 1;
  banned: 0 | 1;
}

export interface GetPricesResponseData {
  total: number;
  page: number;
  pages: number;
  perPage: number;
  skins: PricingItem[];
}

export interface ScrapeResponseData {
  buy_orders: number[];   // in keys
  sell_orders: number[];  // in keys
  algo_orders: number[];  // in keys
  price: string;          // in keys
}

export const CATEGORY_LABELS: Record<PricingCategory, string> = {
  unusuals: 'Unusuals',
  general: 'General',
  strange: 'Strange',
  haunted: 'Haunted',
  vintage: 'Vintage',
  "collector's": "Collector's",
};

export const CATEGORY_COLORS: Record<string, string> = {
  unusuals: 'purple',
  unusual: 'purple',
  general: 'gray',
  strange: 'yellow',
  haunted: 'green',
  vintage: 'ocean',
  "collector's": 'red',
};
